import { Injectable } from '@angular/core';
import { Subcategory } from './subcategory.model';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  subcategoryData: Subcategory;

  constructor(private firestore:AngularFirestore) { }

  getSubcategory(){
    return this.firestore.collection('subCategory', x => x.orderBy('order', 'asc')).snapshotChanges();
  }
}
